export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/5 py-12 px-6 lg:px-12"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span
            className="text-lg tracking-[0.15em] uppercase font-light"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            <span className="gold-text font-semibold">Ellantes</span>
          </span>
          <span className="text-white/20">|</span>
          <span
            className="text-xs text-white/30 tracking-widest uppercase"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Cami X
          </span>
        </div>

        <div className="flex items-center gap-8">
          <a
            href="#technology"
            className="text-xs text-white/30 hover:text-[#D4AF37] transition-colors tracking-wider uppercase"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Technology
          </a>
          <a
            href="#results"
            className="text-xs text-white/30 hover:text-[#D4AF37] transition-colors tracking-wider uppercase"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Results
          </a>
          <a
            href="#features"
            className="text-xs text-white/30 hover:text-[#D4AF37] transition-colors tracking-wider uppercase"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Features
          </a>
        </div>

        <p
          className="text-xs text-white/20 tracking-wide"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          &copy; {new Date().getFullYear()} Ellantes. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
